import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/firebaseConfig';
import { ref, onValue } from 'firebase/database';

function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Real-time listener for System Logs
  useEffect(() => {
    const logsRef = ref(db, 'adminLogs');
    const unsubscribe = onValue(logsRef, (snapshot) => {
      setLoading(true);
      if (snapshot.exists()) {
        const data = snapshot.val();
        const parsedLogs = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        
        // Sort newest first
        parsedLogs.sort((a, b) => b.timestamp - a.timestamp);
        setLogs(parsedLogs);
      } else {
        setLogs([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const getLogColor = (actionStr) => {
    const str = actionStr.toLowerCase();
    if (str.includes('delete') || str.includes('terminate')) return '#ff375f'; // Red
    if (str.includes('downgrade') || str.includes('suspend') || str.includes('all')) return '#ffa116'; // Orange
    return '#00ffae'; // Green (Info/Safe actions)
  }

  return (
    <div className="animate-up">
      <div className="admin-page-header">
        <h1>System Logs</h1>
        <p>Real-time terminal output of platform events.</p>
      </div>

      <div className="admin-card" style={{fontFamily: 'monospace', background: '#090d13', border: '1px solid #30363d'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px solid #30363d', color: '#8b949e'}}>
          <i className="fa-solid fa-terminal"></i> devtracker-production-logs
        </div>

        {loading ? (
          <div style={{color: '#8b949e'}}>Connecting to daemon...</div>
        ) : (
          <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
            {logs.length === 0 ? (
              <div style={{color: '#8b949e'}}>[SYS] No administrative actions recorded yet.</div>
            ) : (
              logs.map(log => (
                <div key={log.id} style={{display: 'flex', gap: '15px', fontSize: '0.9rem', lineHeight: '1.4'}}>
                  <span style={{color: '#8b949e', whiteSpace: 'nowrap'}}>[{new Date(log.timestamp).toLocaleString()}]</span>
                  <span style={{color: '#c9d1d9', fontFamily: 'monospace', whiteSpace: 'nowrap'}}>[{log.logId || 'LOG-DVT-LEGACY'}]</span>
                  <span style={{color: '#00ffae', fontFamily: 'monospace', whiteSpace: 'nowrap', width: '130px'}}>{log.adminId}</span>
                  <span style={{color: getLogColor(log.action)}}>{log.action} <span style={{color: '#8b949e', marginLeft: '5px'}}>→ {log.target}</span></span>
                </div>
              ))
            )}
            <div style={{color: '#8b949e', marginTop: '20px'}}>_</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminLogs;
